/*! @preserve
 * numeral.js
 * version : 1.5.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function () {
  /************************************
      Variables
  ************************************/
  var _numeral,
      VERSION = '1.5.6',
      // internal storage for language config files
  languages = {},
      defaults = {
    currentLanguage: 'en',
    zeroFormat: null,
    nullFormat: null,
    defaultFormat: '0,0'
  },
      options = {
    currentLanguage: defaults.currentLanguage,
    zeroFormat: defaults.zeroFormat,
    nullFormat: defaults.nullFormat,
    defaultFormat: defaults.defaultFormat
  },
      byteSuffixes = {
    bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    iec: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  };
  /************************************
      Constructors
  ************************************/
  // Numeral prototype object


  function Numeral(number) {
    this._value = number;
  }
  /**
   * Implementation of toFixed() that treats floats more like decimals
   *
   * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
   * problems for accounting- and finance-related software.
   */


  function toFixed(value, maxDecimals, roundingFunction, optionals) {
    var splitValue = value.toString().split('.'),
        minDecimals = maxDecimals - (optionals || 0),
        boundedPrecision,
        optionalsRegExp,
        power,
        output; // Use the smallest precision value possible to avoid errors from floating point representation

    if (splitValue.length === 2) {
      boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
    } else {
      boundedPrecision = minDecimals;
    }

    power = Math.pow(10, boundedPrecision); //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
    // Multiply up by precision, round accurately, then divide and use native toFixed():

    output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);

    if (optionals > maxDecimals - boundedPrecision) {
      optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
      output = output.replace(optionalsRegExp, '');
    }

    return output;
  }
  /************************************
      Formatting
  ************************************/
  // determine what type of formatting we need to do


  function formatNumeral(n, format, roundingFunction) {
    var output;

    if (n._value === 0 && options.zeroFormat !== null) {
      output = options.zeroFormat;
    } else if (n._value === null && options.nullFormat !== null) {
      output = options.nullFormat;
    } else {
      // figure out what kind of format we are dealing with
      if (format.indexOf('$') > -1) {
        output = formatCurrency(n, format, roundingFunction);
      } else if (format.indexOf('%') > -1) {
        output = formatPercentage(n, format, roundingFunction);
      } else if (format.indexOf(':') > -1) {
        output = formatTime(n, format);
      } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
        output = formatBytes(n, format, roundingFunction);
      } else if (format.indexOf('o') > -1) {
        output = formatOrdinal(n, format, roundingFunction);
      } else {
        output = formatNumber(n._value, format, roundingFunction);
      }
    }

    return output;
  }

  function formatCurrency(n, format, roundingFunction) {
    var symbolIndex = format.indexOf('$'),
        openParenIndex = format.indexOf('('),
        minusSignIndex = format.indexOf('-'),
        space = '',
        spliceIndex,
        output; // check for space before or after currency

    if (format.indexOf(' $') > -1) {
      space = ' ';
      format = format.replace(' $', '');
    } else if (format.indexOf('$ ') > -1) {
      space = ' ';
      format = format.replace('$ ', '');
    } else {
      format = format.replace('$', '');
    } // format the number


    output = formatNumber(n._value, format, roundingFunction, false); // position the symbol

    if (symbolIndex <= 1) {
      if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
        output = output.split('');
        spliceIndex = 1;

        if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
          // the symbol appears before the "(" or "-"
          spliceIndex = 0;
        }

        output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
        output = output.join('');
      } else {
        output = languages[options.currentLanguage].currency.symbol + space + output;
      }
    } else {
      if (output.indexOf(')') > -1) {
        output = output.split('');
        output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
        output = output.join('');
      } else {
        output = output + space + languages[options.currentLanguage].currency.symbol;
      }
    }

    return output;
  }

  function formatPercentage(n, format, roundingFunction) {
    var space = '',
        output,
        value = n._value * 100; // check for space before %

    if (format.indexOf(' %') > -1) {
      space = ' ';
      format = format.replace(' %', '');
    } else {
      format = format.replace('%', '');
    }

    output = formatNumber(value, format, roundingFunction);

    if (output.indexOf(')') > -1) {
      output = output.split('');
      output.splice(-1, 0, space + '%');
      output = output.join('');
    } else {
      output = output + space + '%';
    }

    return output;
  }

  function formatBytes(n, format, roundingFunction) {
    var output,
        suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
        value = n._value,
        suffix = '',
        power,
        min,
        max; // check for space before

    if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
      suffix = ' ';
      format = format.replace(' ib', '').replace(' b', '');
    } else {
      format = format.replace('ib', '').replace('b', '');
    }

    for (power = 0; power <= suffixes.length; power++) {
      min = Math.pow(1024, power);
      max = Math.pow(1024, power + 1);

      if (value === null || value === 0 || value >= min && value < max) {
        suffix += suffixes[power];

        if (min > 0) {
          value = value / min;
        }

        break;
      }
    }

    output = formatNumber(value, format, roundingFunction);
    return output + suffix;
  }

  function formatOrdinal(n, format, roundingFunction) {
    var output,
        ordinal = ''; // check for space before

    if (format.indexOf(' o') > -1) {
      ordinal = ' ';
      format = format.replace(' o', '');
    } else {
      format = format.replace('o', '');
    }

    ordinal += languages[options.currentLanguage].ordinal(n._value);
    output = formatNumber(n._value, format, roundingFunction);
    return output + ordinal;
  }

  function formatTime(n) {
    var hours = Math.floor(n._value / 60 / 60),
        minutes = Math.floor((n._value - hours * 60 * 60) / 60),
        seconds = Math.round(n._value - hours * 60 * 60 - minutes * 60);
    return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
  }

  function formatNumber(value, format, roundingFunction) {
    var negP = false,
        signed = false,
        optDec = false,
        abbr = '',
        abbrK = false,
        // force abbreviation to thousands
    abbrM = false,
        // force abbreviation to millions
    abbrB = false,
        // force abbreviation to billions
    abbrT = false,
        // force abbreviation to trillions
    abbrForce = false,
        // force abbreviation
    abs,
        min,
        max,
        power,
        w,
        precision,
        thousands,
        d = '',
        neg = false;

    if (value === null) {
      value = 0;
    }

    abs = Math.abs(value); // see if we should use parentheses for negative number or if we should prefix with a sign
    // if both are present we default to parentheses

    if (format.indexOf('(') > -1) {
      negP = true;
      format = format.slice(1, -1);
    } else if (format.indexOf('+') > -1) {
      signed = true;
      format = format.replace(/\+/g, '');
    } // see if abbreviation is wanted


    if (format.indexOf('a') > -1) {
      // check if abbreviation is specified
      abbrK = format.indexOf('aK') >= 0;
      abbrM = format.indexOf('aM') >= 0;
      abbrB = format.indexOf('aB') >= 0;
      abbrT = format.indexOf('aT') >= 0;
      abbrForce = abbrK || abbrM || abbrB || abbrT; // check for space before abbreviation

      if (format.indexOf(' a') > -1) {
        abbr = ' ';
      }

      format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');

      if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
        // trillion
        abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
        value = value / Math.pow(10, 12);
      } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
        // billion
        abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
        value = value / Math.pow(10, 9);
      } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
        // million
        abbr = abbr + languages[options.currentLanguage].abbreviations.million;
        value = value / Math.pow(10, 6);
      } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
        // thousand
        abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
        value = value / Math.pow(10, 3);
      }
    }

    if (format.indexOf('[.]') > -1) {
      optDec = true;
      format = format.replace('[.]', '.');
    }

    w = value.toString().split('.')[0];
    precision = format.split('.')[1];
    thousands = format.indexOf(',');

    if (precision) {
      if (precision.indexOf('[') > -1) {
        precision = precision.replace(']', '');
        precision = precision.split('[');
        d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
      } else {
        d = toFixed(value, precision.length, roundingFunction);
      }

      w = d.split('.')[0];

      if (d.indexOf('.') > -1) {
        d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
      } else {
        d = '';
      }

      if (optDec && Number(d.slice(1)) === 0) {
        d = '';
      }
    } else {
      w = toFixed(value, null, roundingFunction);
    } // format number


    if (w.indexOf('-') > -1) {
      w = w.slice(1);
      neg = true;
    }

    if (thousands > -1) {
      w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
    }

    if (format.indexOf('.') === 0) {
      w = '';
    }

    return (negP && neg ? '(' : '') + (!negP && neg ? '-' : '') + (!neg && signed ? '+' : '') + w + d + (abbr ? abbr : '') + (negP && neg ? ')' : '');
  }
  /************************************
      Unformatting
  ************************************/
  // revert to number


  function unformatNumeral(n, string) {
    var stringOriginal = string,
        thousandRegExp,
        millionRegExp,
        billionRegExp,
        trillionRegExp,
        bytesMultiplier = false,
        power,
        value;

    if (string.indexOf(':') > -1) {
      value = unformatTime(string);
    } else {
      if (string === options.zeroFormat || string === options.nullFormat) {
        value = 0;
      } else {
        if (languages[options.currentLanguage].delimiters.decimal !== '.') {
          string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
        } // see if abbreviations are there so that we can multiply to the correct number


        thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
        millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
        billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
        trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$'); // see if bytes are there so that we can multiply to the correct number

        for (power = 1; power <= byteSuffixes.bytes.length; power++) {
          bytesMultiplier = string.indexOf(byteSuffixes.bytes[power]) > -1 || string.indexOf(byteSuffixes.iec[power]) > -1 ? Math.pow(1024, power) : false;

          if (bytesMultiplier) {
            break;
          }
        } // do some math to create our number


        value = bytesMultiplier ? bytesMultiplier : 1;
        value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
        value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
        value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
        value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1; // check for percentage

        value *= string.indexOf('%') > -1 ? 0.01 : 1; // check for negative number

        value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1; // remove non numbers

        value *= Number(string.replace(/[^0-9\.]+/g, '')); // round if we are talking about bytes

        value = bytesMultiplier ? Math.ceil(value) : value;
      }
    }

    n._value = value;
    return n._value;
  }

  function unformatTime(string) {
    var timeArray = string.split(':'),
        seconds = 0; // turn hours and minutes into seconds and add them all up

    if (timeArray.length === 3) {
      // hours
      seconds = seconds + Number(timeArray[0]) * 60 * 60; // minutes

      seconds = seconds + Number(timeArray[1]) * 60; // seconds

      seconds = seconds + Number(timeArray[2]);
    } else if (timeArray.length === 2) {
      // minutes
      seconds = seconds + Number(timeArray[0]) * 60; // seconds

      seconds = seconds + Number(timeArray[1]);
    }

    return Number(seconds);
  }
  /************************************
      Top Level Functions
  ************************************/


  _numeral = function numeral(input) {
    if (_numeral.isNumeral(input)) {
      input = input.value();
    } else if (input === 0 || typeof input === 'undefined') {
      input = 0;
    } else if (input === null) {
      input = null;
    } else if (!Number(input)) {
      input = _numeral.fn.unformat(input);
    } else {
      input = Number(input);
    }

    return new Numeral(input);
  }; // version number


  _numeral.version = VERSION; // compare numeral object

  _numeral.isNumeral = function (obj) {
    return obj instanceof Numeral;
  }; // This function will load languages and then set the global language.  If
  // no arguments are passed in, it will simply return the current global
  // language key.


  _numeral.language = function (key, values) {
    if (!key) {
      return options.currentLanguage;
    }

    key = key.toLowerCase();

    if (key && !values) {
      if (!languages[key]) {
        throw new Error('Unknown language : ' + key);
      }

      options.currentLanguage = key;
    }

    if (values || !languages[key]) {
      loadLanguage(key, values);
    }

    return _numeral;
  };

  _numeral.reset = function () {
    for (var property in defaults) {
      options[property] = defaults[property];
    }
  }; // This function provides access to the loaded language data.  If
  // no arguments are passed in, it will simply return the current
  // global language object.


  _numeral.languageData = function (key) {
    if (!key) {
      return languages[options.currentLanguage];
    }

    if (!languages[key]) {
      throw new Error('Unknown language : ' + key);
    }

    return languages[key];
  };

  _numeral.language('en', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
    },
    currency: {
      symbol: '$'
    }
  });

  _numeral.zeroFormat = function (format) {
    options.zeroFormat = typeof format === 'string' ? format : null;
  };

  _numeral.nullFormat = function (format) {
    options.nullFormat = typeof format === 'string' ? format : null;
  };

  _numeral.defaultFormat = function (format) {
    options.defaultFormat = typeof format === 'string' ? format : '0.0';
  };

  _numeral.validate = function (val, culture) {
    var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, languageData, temp; //coerce val to string


    if (typeof val !== 'string') {
      val += '';

      if (console.warn) {
        console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
      }
    } //trim whitespaces from either sides


    val = val.trim(); //if val is just digits return true

    if (!!val.match(/^\d+$/)) {
      return true;
    } //if val is empty return false


    if (val === '') {
      return false;
    } //get the decimal and thousands separator from numeral.languageData


    try {
      //check if the culture is understood by numeral. if not, default it to current language
      languageData = _numeral.languageData(culture);
    } catch (e) {
      languageData = _numeral.languageData(_numeral.language());
    } //setup the delimiters and currency symbol based on culture/language


    _currSymbol = languageData.currency.symbol;
    _abbrObj = languageData.abbreviations;
    _decimalSep = languageData.delimiters.decimal;

    if (languageData.delimiters.thousands === '.') {
      _thousandSep = '\\.';
    } else {
      _thousandSep = languageData.delimiters.thousands;
    } // validating currency symbol


    temp = val.match(/^[^\d]+/);

    if (temp !== null) {
      val = val.substr(1);

      if (temp[0] !== _currSymbol) {
        return false;
      }
    } //validating abbreviation symbol


    temp = val.match(/[^\d]+$/);

    if (temp !== null) {
      val = val.slice(0, -1);

      if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
        return false;
      }
    }

    _thousandRegEx = new RegExp(_thousandSep + '{2}');

    if (!val.match(/[^\d.,]/g)) {
      _valArray = val.split(_decimalSep);

      if (_valArray.length > 2) {
        return false;
      } else {
        if (_valArray.length < 2) {
          return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
        } else {
          if (_valArray[0].length === 1) {
            return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          } else {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          }
        }
      }
    }

    return false;
  };
  /************************************
      Helpers
  ************************************/


  function loadLanguage(key, values) {
    languages[key] = values;
  }
  /************************************
      Floating-point helpers
  ************************************/
  // The floating-point helper functions and implementation
  // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
  // Production steps of ECMA-262, Edition 5, 15.4.4.21
  // Reference: http://es5.github.io/#x15.4.4.21


  if (!Array.prototype.reduce) {
    Array.prototype.reduce = function (callback
    /*, initialValue*/
    ) {
      'use strict';

      if (this === null) {
        throw new TypeError('Array.prototype.reduce called on null or undefined');
      }

      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }

      var t = Object(this),
          len = t.length >>> 0,
          k = 0,
          value;

      if (arguments.length === 2) {
        value = arguments[1];
      } else {
        while (k < len && !(k in t)) {
          k++;
        }

        if (k >= len) {
          throw new TypeError('Reduce of empty array with no initial value');
        }

        value = t[k++];
      }

      for (; k < len; k++) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }

      return value;
    };
  }
  /**
   * Computes the multiplier necessary to make x >= 1,
   * effectively eliminating miscalculations caused by
   * finite precision.
   */


  function multiplier(x) {
    var parts = x.toString().split('.');

    if (parts.length < 2) {
      return 1;
    }

    return Math.pow(10, parts[1].length);
  }
  /**
   * Given a variable number of arguments, returns the maximum
   * multiplier that must be used to normalize an operation involving
   * all of them.
   */


  function correctionFactor() {
    var args = Array.prototype.slice.call(arguments);
    return args.reduce(function (prev, next) {
      var mp = multiplier(prev),
          mn = multiplier(next);
      return mp > mn ? mp : mn;
    }, -Infinity);
  }
  /************************************
      Numeral Prototype
  ************************************/


  _numeral.fn = Numeral.prototype = {
    clone: function clone() {
      return _numeral(this);
    },
    format: function format(inputString, roundingFunction) {
      return formatNumeral(this, inputString ? inputString : options.defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
    },
    unformat: function unformat(inputString) {
      if (Object.prototype.toString.call(inputString) === '[object Number]') {
        return inputString;
      }

      return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
    },
    value: function value() {
      return this._value;
    },
    valueOf: function valueOf() {
      return this._value;
    },
    set: function set(value) {
      this._value = Number(value);
      return this;
    },
    add: function add(value) {
      var corrFactor = correctionFactor.call(null, this._value, value);

      function cback(accum, curr, currI, O) {
        return accum + corrFactor * curr;
      }

      this._value = [this._value, value].reduce(cback, 0) / corrFactor;
      return this;
    },
    subtract: function subtract(value) {
      var corrFactor = correctionFactor.call(null, this._value, value);

      function cback(accum, curr, currI, O) {
        return accum - corrFactor * curr;
      }

      this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
      return this;
    },
    multiply: function multiply(value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = correctionFactor(accum, curr);
        return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
      }

      this._value = [this._value, value].reduce(cback, 1);
      return this;
    },
    divide: function divide(value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = correctionFactor(accum, curr);
        return accum * corrFactor / (curr * corrFactor);
      }

      this._value = [this._value, value].reduce(cback);
      return this;
    },
    difference: function difference(value) {
      return Math.abs(_numeral(this._value).subtract(value).value());
    }
  };
  /************************************
      Exposing Numeral
  ************************************/
  // CommonJS module is defined

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = _numeral;
  }
  /*global ender:false */


  if (typeof ender === 'undefined') {
    // here, `this` means `window` in the browser, or `global` on the server
    // add `numeral` as a global object via a string identifier,
    // for Closure Compiler 'advanced' mode
    this['numeral'] = _numeral;
  }
  /*global define:false */


  if (typeof define === 'function' && define.amd) {
    define([], function () {
      return _numeral;
    });
  }
}).call(this);